export function extractMcpToolQuery(toolInput: unknown): string | undefined {
  if (!toolInput || typeof toolInput !== 'object') {
    return undefined
  }

  const input = toolInput as Record<string, unknown>

  if (typeof input.query === 'string' && input.query.length > 0) {
    return input.query
  }

  if (typeof input.q === 'string' && input.q.length > 0) {
    return input.q
  }

  return undefined
}
